import React, { useEffect, createContext, useState } from 'react';
import PropTypes from 'prop-types';
import useRestApiClient from 'src/hooks/useRestApiClient';

const initialState = {
  jobs: []
};

const JobsContext = createContext({
  ...initialState,
  refreshJobs: () => Promise.resolve()
});

export const JobsProvider = (props) => {
  const { children } = props;
  const [jobs, setJobs] = useState([]);
  const controller = new AbortController();
  const client = useRestApiClient();

  const refreshJobs = async () => {
    const result = await client.get('/logs', {
      signal: controller.signal
    });
    if (!result.data.error) {
      setJobs(result.data.message);
    } else {
      setJobs([]);
    }
  };

  useEffect(() => {
    refreshJobs();
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <JobsContext.Provider
      value={{
        jobs,
        refreshJobs
      }}
      {...props}
    >
      {children}
    </JobsContext.Provider>
  );
};

JobsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default JobsContext;
